const debounce = (func, wait, immediate, ...rest) => {
  let timeout;
  return () => {
    const context = this
    const args = rest
    const later = () => {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

exports.debounce = debounce
